import { isNodeJs } from './env';
export function getBaseUrl(baseUrl) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var localBaseUrl = baseUrl.trim().replace(/\/*$/gi, '');
    if (!isNodeJs()) {
        return localBaseUrl || window.location.origin;
    }
    return localBaseUrl || '';
}
//# sourceMappingURL=url.js.map